import AppRouter from 'common/AppRouter';
import keyBy from 'lodash/keyBy';
import { useMemo } from 'react';
import { useLocation } from 'react-router';

/**
 * Controls which filters are disabled based on route
 */
export function useTopBarFiltersStateByRoute() {
  const location = useLocation();
  const routesByPath = useMemo(() => keyBy(AppRouter, 'path'), []);
  const routeOptions = useMemo(
    () => routesByPath?.[location.pathname]?.options,
    [location.pathname]
  );

  return {
    disableTeamPickerByRoute: routeOptions?.disableTeamPicker,
    disablePeriodPicker: routeOptions?.disableDatePicker
  };
}
